import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import MainFeature from "components/features/TwoColWithButton.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";

import foxyHunterSrc from "images/foxy.png";
import tokenomicSrc from "images/tokenomics.png";
export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8 text-gray-600`;
  const imageCss = tw`rounded-4xl`;
  return (
    <AnimationRevealPage>
      <Hero
        heading={
          <>
            The Meme Token for the <HighlightedText>Underdogs.</HighlightedText>
          </>
        }
        description="The meme token for those attempting to create an upset in a challenging field. We are a community whose purpose is to cheer one another."
        imageSrc={foxyHunterSrc}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="How to Buy"
        primaryButtonUrl="https://www.forthewin.network/#/swap/trade?tokenA=d2a4cff31913016155e38e474a2c06d08be276cf&tokenB=aeb697166d5cb3376757983b23df1be8292364d0&symbolA=GAS&symbolB=FOXES"
        watchVideoButtonText="Meet The Foxy Hunters"
      />
      <MainFeature
        subheading={<Subheading>Tokenomics</Subheading>}
        heading={
          <>
            The total supply of $FOXES will be
            <wbr /> <HighlightedText>50 billion.</HighlightedText>
          </>
        }
        description={
          <Description>
            The Foxy Hunters token ($FOXES) is a Neo token of the NEP-17
            Standard.
            <br />
            <br />
            There will be a periodic burn of FOXES tokens. The burn will be a
            result of token buy-back from revenue generated by various Foxy
            Hunters Project.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Read More"
        imageSrc={tokenomicSrc}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      <TabGrid
        heading={
          <>
            Checkout our <HighlightedText>NFTs.</HighlightedText>
          </>
        }
      />
      <Footer />
    </AnimationRevealPage>
  );
};
